var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":_vm.$vuetify.breakpoint.mobile}},_vm._l((_vm.data),function(shopData){return _c('v-col',{key:shopData.shopCode,attrs:{"cols":"12","sm":"6"}},[_c('ShopStatisticCard',{attrs:{"shop-statistic":shopData}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }